import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessageActivityOneninetwoEmptyPrimary = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 192,
	height: 192,
	viewBox: "0 0 192 192",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M23.8654 37.2V36.2C23.8654 31.8 27.4654 28.2 31.8654 28.2H127.865C132.265 28.2 135.865 31.8 135.865 36.2V48.2C135.865 61.2 127.865 64.2 123.865 60.2C119.865 56.2 121.865 50.2 130.865 47.2L144.265 42.7C148.465 41.3 152.965 43.5999 154.365 47.7999L181.265 128.6C182.665 132.8 180.365 137.3 176.165 138.7L83.3654 169.6C79.1654 171 74.6654 168.7 73.2654 164.5L67.7654 148.1M57.8654 54.2H75.8654M135.865 66.2V132.2C135.865 136.6 132.265 140.2 127.865 140.2H31.8654C27.4654 140.2 23.8654 136.6 23.8654 132.2V65.2C23.8654 64.7 23.4654 64.3 22.9654 64.2C17.7654 63.7 13.6654 59.3 13.8654 53.9C14.0654 48.8 18.1654 44.5 23.3654 44.2C26.6654 44 29.5654 45.4 31.5654 47.7L39.0654 46.7999C40.7654 41.6999 44.0654 38.2 47.9654 38.2C53.4654 38.2 57.9654 45.4 57.9654 54.2C57.9654 63 53.4654 70.2 47.9654 70.2C44.0654 70.2 40.6654 66.3 38.9654 61.2L31.9654 60.2M43.8654 93.3L47.3654 89.7999C50.4654 86.6999 55.8654 88.9 55.8654 93.3C55.8654 97.7 61.2654 99.9 64.3654 96.8L71.3654 89.7999C74.4654 86.6999 79.8654 88.9 79.8654 93.3C79.8654 97.7 85.2654 99.9 88.3654 96.8L95.3654 89.7999C98.4654 86.6999 103.865 88.9 103.865 93.3C103.865 97.7 109.265 99.9 112.365 96.8L115.865 93.3M43.8654 115.3L47.3654 111.8C50.4654 108.7 55.8654 110.9 55.8654 115.3C55.8654 119.7 61.2654 121.9 64.3654 118.8L71.3654 111.8C74.4654 108.7 79.8654 110.9 79.8654 115.3C79.8654 119.7 85.2654 121.9 88.3654 118.8L95.3654 111.8C98.4654 108.7 103.865 110.9 103.865 115.3C103.865 119.7 109.265 121.9 112.365 118.8L115.865 115.3",
		stroke: "url(#paint0_linear_4_1557)",
		strokeWidth: 2.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_4_1557",
		x1: 97.7671,
		y1: 28.2,
		x2: 97.7671,
		y2: 170.01,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#93C437" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#279BE8"
		})]
	}) })]
});
export default SvgMessageActivityOneninetwoEmptyPrimary;
